import { create } from 'zustand';

interface ManageVisitReportModalState {
  slug: string;
  isOpen: boolean;
  onManageVisitReportModalClose: () => void;
  onManageVisitReportModalOpen: (slug: string) => void;
}

export const useManageVisitReportModalStore = create<ManageVisitReportModalState>(set => ({
  isOpen: false,
  slug: '',
  onManageVisitReportModalClose: () => set({ isOpen: false, slug: '' }),
  onManageVisitReportModalOpen: (slug: string) => set({ isOpen: true, slug }),
}));
